const getDomain = () => {
  const isDevelopment = process.env.NODE_ENV === "development";
  let domain = "https://gleamdesk.com"

  if (isDevelopment) {
    domain = "http://localhost:3000"
  }

  return domain;
}

export default getDomain;
